/* istanbul ignore file */

import _ from 'underscore';
import $ from 'jquery';

const DEFAULT_LOCALE = 'US';
const DEFAULT_MARKET = 'en-US';
const DEFAULT_PROJECT = 'bing_ads';

function isApexDisabled() {
  const uri = new URL(window.location.href);
  return uri.searchParams && _.isFunction(uri.searchParams.get) && uri.searchParams.get('apexDisabled') === 'true';
}

export function initApexPlatform({
  currentLocale,
  userContext = {},
  supportOptions: supportConfigs = {},
  helpModel = {},
  apexConfig = {},
  onRailViewOpen,
  onRailViewClose,
  onPopupOpen,
  onPopupClose,
  renderApexHelpSuggestions,
  renderSearchInputIcon,
}, log) {
  if (_.isFunction($.fn.InitApexPlatform)) {
    window.config = {
      getScriptForAds: (reserved, init) => { init(); },
    };

    const currentAccount = userContext.CurrentAccount || {};
    const currentCustomer = userContext.CurrentCustomer || {};
    const currentUser = userContext.CurrentUser || {};

    const phoneSupportSchedule = supportConfigs.PhoneSupportSchedule || {};
    const emailSupportSchedule = supportConfigs.EmailSupportSchedule || {};

    const market = currentLocale || currentUser.Market || DEFAULT_LOCALE;
    const supportMarket = helpModel.SupportMarket || DEFAULT_MARKET;

    // Can be overridden, useful for DMC feature
    const Project = apexConfig.Project || DEFAULT_PROJECT;
    let EndPoint = apexConfig.EndPoint || helpModel.BaseHelpUrl;
    // If apexDisabled flag is true, reset apex endpoint to a fake URL
    if (isApexDisabled()) {
      EndPoint = 'https://help.notexist.microsoft.com';
    }

    const SourceEndPoint = apexConfig.SourceEndPoint ? apexConfig.SourceEndPoint : undefined;
    const apexInitOptions = {
      SupportOptions: {
        AccountNumber: currentAccount.AccountNumber || '',
        AccountName: currentAccount.ShortName || currentAccount.Name,
        CustomerId: currentCustomer.Id || '',
        CustomerName: currentCustomer.Name || '',
        UserName: currentUser.Name || '',
        UserEmail: currentUser.Email,
        ShowLivePerson: supportConfigs.IfShowLiveChat,
        LivePersonSection: supportConfigs.LiveChatSection,
        PhoneLabel: supportConfigs.PhoneSupportLabel,
        Phone: supportConfigs.IfShowPhoneSupport ? supportConfigs.PhoneSupportNumber : null,
        PhoneInterval: phoneSupportSchedule.Interval,
        PhoneTimeZone: phoneSupportSchedule.TimeZone,
        EmailLabel: supportConfigs.EmailSupportEmail,
        Email: supportConfigs.EmailSupportEmail,
        EmailInterval: emailSupportSchedule.Interval,
        EmailTimeZone: emailSupportSchedule.TimeZone,
        AskCommunity: supportConfigs.CommunityUrl,
        DisableSupportChat: supportConfigs.DisableSupportChat,
      },
      Project,
      Market: market,
      EndPoint,
      SourceEndPoint,
      Success: null,
      SupportMarket: supportMarket,
      InitAnswerBar: false,
      InitPopup: true,
      InitOnReady: false,
      onRailViewOpen,
      onRailViewClose,
      onPopupOpen,
      onPopupClose,
      renderApexHelpSuggestions,
      renderSearchInputIcon,
    };

    if (log) {
      log(`helpModel: apexInitOptions: ${JSON.stringify(apexInitOptions)}`);
    }

    if (window.apex_glb && window.apex_glb.Initialized) {
      // If apex is already initialized, we need to update the global variables
      // Use _.omit to remove undefined values
      _.extend(window.apex_glb, _.omit({
        SupportOptions: apexInitOptions.SupportOptions,
        Project,
        Market: market,
        EndPoint,
        SourceEndPoint,
        SupportMarket: supportMarket,
      }, _.isUndefined));
    } else {
      $.fn.InitApexPlatform(apexInitOptions);
    }
  }
}
